import axios from "../../../axios";

export function getCustomOrderList() {
  const response = axios.post(`/products/custom-products/`);
  return response;
}

export function fetchCustomOrderDetails(id: any) {
  const response = axios.get(`products/custom-product/${id}/`);
  return response;
}
export function setCustomOrder(id: any, payload: any) {
  const response = axios.post(`orders/customorder/${id}/`, payload);
  return response;
}
